<template>
  <div>
    <data-table :service="service"
                :entity="entity"
                :columns="columns"
                :disable-permission-checks="true"
                operations="add,edit,delete"
                ref="table">
      <template v-slot:job_board_id="{row}">
        <router-link v-if="row.job_board_id" :to="`/content/job-board/${row.job_board_id}`" @click.native.stop="">
          {{getJobBoardName(row.job_board_id) || $t('generic.na')}}
        </router-link>
        <span v-else>
          {{getJobBoardName(row.job_board_id) || $t('generic.na')}}
        </span>
      </template>
      <template v-slot:query="{row}">
          <div v-if="row.query">
            <div v-if="row.query.search" class="d-flex align-items-center mb-1">
              <span class="mr-1 mb-1">{{$t('generic.keywords')}}:</span>
              <div>
                <badge v-for="keyword in row.query.search"
                       :key="keyword"
                       type="info"
                       class="mr-1 mb-1">
                  {{keyword}}
                </badge>
              </div>
            </div>
            <div v-if="row.query.segments" class="flex items-center mb-1">
              <span class="mr-1 mb-1">{{$t('generic.segments')}}:</span>
              <div>
                <badge v-for="segmentId in row.query.segments"
                       :key="segmentId"
                       class="mr-1 mb-1">
                  <span>{{getSegmentById(segmentId).value}}</span>
                </badge>
              </div>
            </div>
            <div v-if="row.query.exclude_search" class="d-flex align-items-center mb-1">
              <span class="mr-1 mb-1">{{$t('generic.excludeKeywords')}}:</span>
              <div>
                <badge v-for="keyword in row.query.exclude_search"
                       :key="keyword"
                       type="danger"
                       class="mr-1 mb-1 d-inline-flex">
                  {{keyword}}
                </badge>
              </div>
            </div>
          </div>
      </template>
      <template v-slot:created_by="{row}">
        <span>{{row.created_by || 'N/A'}}</span>
      </template>
      <template v-slot:created_at="{row}">
        <span>{{$formatDate(row.created_at, FRIENDLY_DATE_FORMAT)}}</span>
      </template>
    </data-table>
  </div>
</template>
<script>
  import { entities } from 'src/config/routeTypes'
  import SearchSuggestionsService from 'src/services/SearchSuggestionsService'
  import { FRIENDLY_DATE_FORMAT } from 'src/config/dateUtils'
  import Badge from 'src/components/Badge'
  export default {
    name: 'search-suggestions-list',
    components: {
      Badge
    },
    data () {
      return {
        service:  SearchSuggestionsService,
        entity: entities.SUGGESTION,
        FRIENDLY_DATE_FORMAT
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'job_board_id',
            label: this.$t('searchSuggestions.list.jobBoard'),
            minWidth: '160px',
            sortable: true
          },
          {
            prop: 'keyword',
            label: this.$t('searchSuggestions.list.keyword'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'query',
            label: this.$t('searchSuggestions.list.query'),
            minWidth: '350px',
            sortable: true
          },
          {
            prop: 'created_by',
            label: this.$t('searchSuggestions.list.createdBy'),
            minWidth: '130px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '130px',
            sortable: true
          }
        ]
      },
      getJobBoardById() {
        return this.$store.getters['config/getJobBoardById']
      },
      getSegmentById() {
        return this.$store.getters['config/getSegmentById']
      },
    },
    methods: {
      getJobBoardName(id) {
        let jobBoard = this.getJobBoardById(id) || {}
        return jobBoard.name
      },
    }
  }
</script>
<style>
</style>
